import { render, staticRenderFns } from "./splideMobile.vue?vue&type=template&id=6aa76c18&scoped=true&"
import script from "./splideMobile.vue?vue&type=script&lang=js&"
export * from "./splideMobile.vue?vue&type=script&lang=js&"
import style0 from "./splideMobile.vue?vue&type=style&index=0&id=6aa76c18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa76c18",
  null
  
)

export default component.exports